import React, { useEffect } from "react";
import FormAddRiwayatPendidikan from '../components/FormAddRiwayatPendidikan'
import Layout from './Layout'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";

const AddRiwayatPendidikan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);
  return (
    <Layout>
        <FormAddRiwayatPendidikan/>
    </Layout>
  )
}

export default AddRiwayatPendidikan